import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import EventCard from '../components/common/card';

const Events = () => {

  const [events, setEvents] = useState([]);

  useEffect(() => {
    const getAllEvents = async () => {
      const { data, error } = await supabase
        .from('event')
        .select(`
          *,
          category:category_id (
            id,
            title,
            title_AR
          )
        `);

      if (error) {
        console.log("Supabase error:", error);
        return;
      }

      setEvents(data);
    };

    getAllEvents();
  }, []);

  return (
    <>
      {events.map((i) => (
        <EventCard
          key={i.id}
          title={i.title}
          location={i.location}
          date={i.date}
          time={i.time}
          price={i.price}
          description={i.description}
          statustxt={i.category?.title} 
          img={i.image}
        />
      ))}
      
    </>
  );
};

export default Events;